import type { JobSearchStatus } from '../../../types/userProfile';

export const PROFILE_INDUSTRY_OPTIONS = [
  { value: 'software', label: 'Software & IT' },
  { value: 'data_ai', label: 'Data & AI' },
  { value: 'design', label: 'Design' },
  { value: 'product', label: 'Product' },
  { value: 'marketing', label: 'Marketing' },
  { value: 'sales', label: 'Sales' },
  { value: 'finance', label: 'Finance' },
  { value: 'operations', label: 'Operations' },
  { value: 'hr', label: 'HR & People' },
  { value: 'healthcare', label: 'Healthcare' },
  { value: 'other', label: 'Other' },
];

export const PROFILE_JOB_SEARCH_STATUS_OPTIONS: { value: JobSearchStatus; label: string }[] = [
  { value: 'actively_looking', label: 'Actively looking' },
  { value: 'open', label: 'Open to offers' },
  { value: 'not_looking', label: 'Not looking' },
];

export const PROFILE_JOB_TYPE_OPTIONS = [
  { value: 'full_time', label: 'Full-time' },
  { value: 'part_time', label: 'Part-time' },
  { value: 'contract', label: 'Contract' },
  { value: 'internship', label: 'Internship' },
  { value: 'remote', label: 'Remote' },
  { value: 'hybrid', label: 'Hybrid' },
  { value: 'onsite', label: 'On-site' },
];
